<tr class="wa-table__row visibility--hide-mobile">
  <td class="wa-table__cell wa-table__cell--fit-right">
    <div class="ranking" data-th="ranking" [ngClass]="{'ranking--square': Ranking.athlete !== undefined}">
      <div class="ranking__position">
        <span>{{ Ranking.rank }}</span>
      </div>
      <div
        class="ranking__status"
        [ngClass]="getClass(Ranking.rank, Ranking.rankPrevious)"
      >
        {{ parseRank(Ranking.rank, Ranking.rankPrevious) }}
      </div>
      <div *ngIf="Ranking.athlete !== undefined; else: teamimage" class="ranking__picture">
        <img
          [lazyLoad]="
            '//extranet.worldarchery.sport/ProfilePictures/?Id=' +
            Ranking.athlete.Id
          "
        />
      </div>
      <ng-template #teamimage>
        <div class="ranking__picture">
          <img
            [lazyLoad]="
              '//extranet.worldarchery.sport/Flags/' +
              Ranking?.team?.NOC +
              '.svg'
            "
          /></div
      ></ng-template>
    </div>
  </td>
  <td class="wa-table__cell">
    <a
      [href]="lang + 'athlete/'+Ranking.athlete?.Id.toString()"
      *ngIf="Ranking.athlete"
      class="athlete"
      data-th="name"
    >
      <div
        [ngClass]="Ranking.athlete.WNameOrd ? 'athlete__lastname' : 'athlete__name'"
      >
        {{
          Ranking.athlete.WNameOrd === true
            ? Ranking.athlete.FName
            : Ranking.athlete.GName
        }}
      </div>
      <div
        [ngClass]="Ranking.athlete.WNameOrd === false ? 'athlete__lastname' : 'athlete__name'"
      >
        {{
          Ranking.athlete.WNameOrd === false
            ? Ranking.athlete.FName
            : Ranking.athlete.GName
        }}
      </div>
    </a>
  </td>
  <td class="wa-table__cell">
    <div
      *ngIf="Ranking.athlete !== undefined; else: team"
      class="country"
      data-th="country"
    >
      <div class="country__img">
        <img [lazyLoad]="'//extranet.worldarchery.sport/Flags/' + Ranking?.athlete?.NOC +'.svg'" />
      </div>
      <div class="country__name">{{ getNameCountry(Ranking?.athlete?.NOC) }}</div>
    </div>
  </td>
  <td class="wa-table__cell">
    <ng-template #team>
      <div class="squad" data-th="team">
        <div class="squad__name">{{ Ranking?.team?.Name }}</div>
      </div>
    </ng-template>
  </td>
  <td class="wa-table__cell">
    <div class="score" data-th="points">
      {{ Ranking.points }}
    </div>
    <div class="qualified" [ngClass]="'qualified--' + Ranking.status">{{ Ranking.statustext }}</div>
  </td>
  <td class="wa-table__cell wa-table__cell--fit-left">
    <div class="list-row-item__action" (click)="onClick()">
      <span class="plus-minus {{showDetails === false ? 'plus-minus--more' : 'plus-minus--less' }}">
      </span>
    </div>
  </td>
</tr>

<div class="wa-table-simple visibility--hide-desktop">
  <div class="wa-table-simple__cell">
    <div class="wa-table-simple__cell__item">
      <div class="ranking" data-th="ranking" [ngClass]="{'ranking--square': Ranking.athlete !== undefined}">
        <div class="ranking__position">
          <span>{{ Ranking.rank }}</span>
        </div>
        <div
          class="ranking__status"
          [ngClass]="getClass(Ranking.rank, Ranking.rankPrevious)"
        >
          {{ parseRank(Ranking.rank, Ranking.rankPrevious) }}
        </div>
        <div *ngIf="Ranking.athlete !== undefined; else: teamimage" class="ranking__picture">
          <img
            [lazyLoad]="
              '//extranet.worldarchery.sport/ProfilePictures/?Id=' +
              Ranking.athlete.Id
            "
          />
        </div>
        <ng-template #teamimage>
          <div class="ranking__picture">
            <img
              [lazyLoad]="
                '//extranet.worldarchery.sport/Flags/' +
                Ranking?.team?.NOC +
                '.svg'
              "
            /></div
        ></ng-template>
      </div>
    </div>
  </div>
  <div class="wa-table-simple__cell">
    <div class="wa-table-simple__cell__item">
      <a
        [href]="lang + 'athlete/'+Ranking.athlete?.Id.toString()"
        *ngIf="Ranking.athlete"
        class="athlete"
        data-th="name"
      >
        <div
          [ngClass]="Ranking.athlete.WNameOrd ? 'athlete__lastname' : 'athlete__name'"
        >
          {{
            Ranking.athlete.WNameOrd === true
              ? Ranking.athlete.FName
              : Ranking.athlete.GName
          }}
        </div>
        <div
          [ngClass]="Ranking.athlete.WNameOrd === false ? 'athlete__lastname' : 'athlete__name'"
        >
          {{
            Ranking.athlete.WNameOrd === false
              ? Ranking.athlete.FName
              : Ranking.athlete.GName
          }}
        </div>
      </a>
    </div>
    <div class="wa-table-simple__cell__item">
      <div
        *ngIf="Ranking.athlete !== undefined; else: team"
        class="country"
        data-th="country"
      >
        <div class="country__name">{{ getNameCountry(Ranking?.athlete?.NOC) }}</div>
        <div class="country__img">
          <img
            [lazyLoad]="
              '//extranet.worldarchery.sport/Flags/' +
              Ranking?.athlete?.NOC +
              '.svg'
            "
          />
        </div>
      </div>
      <ng-template #team>
        <div class="squad" data-th="team">
          <div class="squad__name">{{ Ranking?.team?.Name }}</div>
        </div>
      </ng-template>
    </div>
    <div class="wa-table-simple__cell__item">
      <div class="qualified" [ngClass]="'qualified--' + Ranking.status">{{ Ranking.statustext }}</div>
    </div>
  </div>
  <div class="wa-table-simple__cell wa-table-simple__cell--right">
    <div class="wa-table-simple__cell__item">
      <div class="score score--extra-small" data-th="points">
        {{ Ranking.points }}
      </div>
    </div>
    <div class="wa-table-simple__cell__item">
      <div class="list-row-item__action" (click)="onClick()">
        <span class="plus-minus {{showDetails === false ? 'plus-minus--more' : 'plus-minus--less' }}">
        </span>
      </div>
    </div>
  </div>
</div>

<tr class="wa-table__row wa-table__row--simple">
  <td class="wa-table__cell wa-table__cell--fit" colspan="100%">
    <app-wcup-rannking-detail
      [details]="Ranking.details"
      *ngIf="showDetails === true"
    ></app-wcup-rannking-detail>
  </td>
</tr>
